/*import gamebuinoImage from "../assets/images/Miniatures/minia-gamebuino.png";
import img1 from "../assets/images/Gamebuino/gamebuino-img1.png";
import img2 from "../assets/images/Gamebuino/gamebuino-img2.png";
import img3 from "../assets/images/Gamebuino/gamebuino-img3.jpg";*/

const gamebuinoData = {
    slug: "gamebuino",
    sections: [
        {
            elements: [
                { type: "en-title", content: "First Person Dungeon Crawler on Arduino Console" },
                { type: "fr-title", content: "Dungeon Crawler a la premiere personne sur console Arduino" },
                //{ type: "imageTitle", src: img1, alt: "Illustration of Game View" }
            ],
        },
        {
            elements: [
                { type: "en-text", content: (<>
                    <h2>Project Overview</h2>

                    <p>This project is one of my <strong>first C++ experiments</strong> on the <a href="https://gamebuino.com/fr" target="_noopener"><strong>Gamebuino</strong></a> console, a platform based on <strong>Arduino</strong>.
                    It's an old-school <strong>dungeon crawler</strong>, developed as an extracurricular project.
                    The game is entirely coded in C++, and the sprites are renderings of 3D scenes created in Blender, then pixelated and converted into 64x64 pixel images, loaded directly as a spritesheet into the console's video memory.
                    The game level is represented by a simple array that directly contains sprite values to display for each cell depending on the direction the player is looking.
                    I also implemented a dynamic map that reveals itself as the player explores the level.</p>
                </>) },
                { type: "fr-text", content: (<>
                    <h2>Présentation du projet</h2>

                    <p>Ce projet est une de mes <strong>premières expérimentations en C++</strong> sur la console <a href="https://gamebuino.com/fr" target="noopener"><strong>Gamebuino</strong></a>, une plateforme basée sur <strong>Arduino</strong>. 
                    Il s’agit d’un <strong>dungeon crawler</strong> à l’ancienne, développé dans le cadre d’un projet extrascolaire. 
                    Le jeu est entièrement codé en C++, et les sprites sont des rendus de scènes 3D réalisées dans Blender, ensuite pixelisées et converties en image de 64x64 pixels, chargée directement comme spritesheet dans la mémoire vidéo de la console. 
                    Le niveau de jeu est représenté par un array simple qui contient directement des valeurs de sprites à afficher pour chaque case selon la direction où le joueur regarde. 
                    J’ai également implémenté une carte dynamique qui se révèle au fur et à mesure que le joueur explore le niveau.</p>
                </>) },
                { type: "video", src: "https://www.youtube.com/embed/FSNNHIu-tww?si=WRYptILuY8FRRs8H" }
            ]
        },
        {
            elements: [
                { type: "en-title", content: "Game Link" },
                { type: "fr-title", content: "Lien du jeu" },
                { type: "link", content: "https://alexandre-kotowicz.itch.io/gamebuino-dungeon-crawler" }
            ]
        }
    ]
};

export default gamebuinoData;